import React, { useEffect, useState } from 'react';
import config from './config';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import MenuIcon from '@mui/icons-material/Menu';
import LockIcon from '@mui/icons-material/Lock';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { Helmet } from 'react-helmet'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import SignIn from './Modules/Authentication/signIn';
import PublicPayInvoice from './Modules/Home/publicPay';
import DefaultSettings from './Utils/settings';
import Loader from './Utils/loader';
import Alert from './Utils/alert';
import Landing from './Modules/Home/main';
import Home from './Modules/Home/';
import AuthProvider from './Modules/Authentication/authProvider';
import Access from './Utils/authorize';
import { useTheme } from '@mui/material/styles';
import Properties from './Modules/Properties';
import Settings from './Modules/Settings';
import CompanyView from './Modules/Company';
import AgreementView from './Modules/Agreements';
import WaitList from './Modules/WaitList';
import Invoices, { InvoiceDetail } from './Modules/Invoices';
import Transactions from './Modules/Transactions';
import MessageView, { MessageFullScreen } from './Modules/Messages'
import LeaseListing from './Modules/WaitList/leasing';
import TieDown from './Modules/WaitList/tiedown';
import MyAccount from './Modules/Settings/myaccount';
import Reports from './Modules/Reports';
import Charts from './Modules/Charts';
import { GetCSRF } from './REST/authenticate'
import AdvancedReports from './Modules/Reports/advancedReports';
import AlertView from './Modules/Alerts';
import AppointmentView from './Modules/Appointment';
import OtherReports from './Modules/Reports/other';
import InspectionMasterList from './Modules/Inspection/inspectionMasterList';
import InspectionDataList from './Modules/Inspection/forms/inspectoinDataList';
import WorkorderMasterList from './Modules/Workorder/workordersMasterList';
import WorkorderDataList from './Modules/Workorder/forms/workorderDataList'
import IncidentReport from './Modules/IncidentReport';
import AIReporting from './Modules/Reports/ai';

import MasterAssetSwitch from './Modules/Asset/MasterAssetSwitch';
import AssetDataList from './Modules/Asset/forms/assetDataList';
import Applicants from './Modules/WaitList/applicants';


import { getAvailable } from './Utils/links';
import AppBarStyled from './themes/components/AppBarStyled';
import DrawerLayout from './themes/components/DrawerLayout';
import { GetSystemSettings } from './REST/utilities';
//import {DateTimeLocale} from './Utils/datetimelocale'

const SIGN_IN_URL = `${config.REACT_APP_COGNITO_URL}/login?response_type=code&client_id=${config.REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${config.REACT_APP_COGNITO_SIGNIN}&scope=${config.REACT_APP_COGNITO_SCOPE}`
const logo = config.REACT_APP_LOGO_IMG

export default function PersistentDrawerRight() {
  const theme = useTheme();
  const navigate = useNavigate()
  const location = useLocation()
  const loaderView = React.useRef(null);
  const alertView = React.useRef(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [dbConfig, setDbConfig] = useState({ 
    appName: 'RevJet 360', 
    logocolor: 'yellow',
    logoImg: logo,
    backgroundImg: config.REACT_APP_BACKGROUND_IMG
  });

  useEffect(() => {
    GetSystemSettings().then((result) => {
      const setting = result.data.find((x) => { return x.name == "appconfig" });
      if (setting && setting.jsonvalue) {
        setDbConfig({
          appName: setting.jsonvalue.REACT_APP_NAME || 'RevJet 360',
          logocolor: setting.jsonvalue.logocolor || 'yellow',
          logoImg: setting.jsonvalue.REACT_APP_LOGO_IMG || logo,
          backgroundImg: setting.jsonvalue.REACT_APP_BACKGROUND_IMG || config.REACT_APP_BACKGROUND_IMG
        });
      }
    }).catch(err => console.error('Failed to load config:', err));
  }, []);

  useEffect(() => {
    if (loaderView && loaderView.current)
      DefaultSettings.setLoader(loaderView.current);
    if (alertView && alertView.current)
      DefaultSettings.setAlert(alertView.current);
  }, [loaderView, alertView])

  const logOut = () => {
    sessionStorage.clear()
    localStorage.clear()
    navigate('/', { replace: true })
  }

  const handleLink = (link, params) => {
    navigate(link, { state: { location: params } })
  }

  useEffect(() => {
    GetCSRF()
  }, [])


  return (
    <>
      <Helmet>
        <title>{dbConfig.appName}</title>
        <script type="text/javascript" src="https://sandbox.web.squarecdn.com/v1/square.js" />
      </Helmet>
      <Loader ref={loaderView} />
      <Alert ref={alertView} />
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />

      <AppBarStyled elevation={0}>
        <Toolbar sx={{ flexWrap: 'nowrap', minHeight: '64px !important', height: '64px' }}>
          {/* Hamburger — only on mobile, only when authenticated */}
          {Access.user() && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open navigation menu"
              onClick={() => setMobileDrawerOpen(true)}
              sx={{ mr: 1, display: { md: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Spacer to push content away from logo — only on root landing page */}
          {!Access.user() && location.pathname === '/' && (
            <Box sx={{ width: { xs: '100px', sm: '160px' }, flexShrink: 0 }} />
          )}

          {!Access.user() && location.pathname === '/listings' && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => navigate('/')}
              sx={{ mr: 2 }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}

          <Typography
            variant="landing-header-text"
            noWrap
            onClick={() => navigate('/')}
            sx={{
              flexGrow: 1,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              visibility: Access.user() ? 'visible' : 'hidden',
 
              color: "WHITE"
 
            }}
          >
            RevJet 360
          </Typography>

          {!Access.user() && location.pathname === '/listings' && (
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2, mr: 2 }}>
              <Applicants navbar />
            </Box>
          )}

          {!Access.user() && (
            <Button
              href={SIGN_IN_URL}
              variant="landing-login"
              startIcon={<LockIcon />}
              sx={{ my: 0.5, mx: 1.5, flexShrink: 0 }}
            >
              Login
            </Button>
          )}
        </Toolbar>
      </AppBarStyled>

      <DrawerLayout
        isAuthenticated={!!Access.user()}
        menuItems={getAvailable()}
        onMenuClick={handleLink}
        onLogout={logOut}
        mobileDrawerOpen={mobileDrawerOpen}
        onMobileDrawerClose={() => setMobileDrawerOpen(false)}
      >
        <MessageView />

        <Routes>
          <Route exact path='/' element={<AuthProvider noAccess={() => <Landing />}><Home /></AuthProvider>} />
          <Route exact path='signin/:code' element={<SignIn />} />
          <Route path='pay/*' element={<PublicPayInvoice />} />
          <Route path='tiedown/*' element={<TieDown />} />
          <Route path='appointment/*' element={<AppointmentView />} />
          <Route path='properties/*' element={<AuthProvider><Properties /></AuthProvider>} />
          <Route path='agreements/*' element={<AuthProvider><AgreementView /></AuthProvider>} />
          <Route path='alerts/*' element={<AuthProvider><AlertView /></AuthProvider>} />
          <Route path='settings/*' element={<AuthProvider key='settings'><Settings key='innerSettings' /></AuthProvider>} />
          <Route path='companies/*' element={<AuthProvider><CompanyView /></AuthProvider>} />
          <Route path='waitlist/*' element={<AuthProvider><WaitList /></AuthProvider>} />
          <Route path='listings/*' element={<LeaseListing />} />
          <Route path='invoices/*' element={<AuthProvider><Invoices /></AuthProvider>} />
          <Route path='transactions' element={<AuthProvider><Transactions /></AuthProvider>} />
          <Route path='myaccount/*' element={<AuthProvider><MyAccount /></AuthProvider>} />
          <Route path='chat/:id' element={<MessageFullScreen />} />
          <Route path='reports' element={<Reports />} />
          <Route path='interactive' element={<OtherReports />} />
          <Route path='charts' element={<Charts />} />
          <Route path='advancedReports' element={<AdvancedReports />} />
          <Route path='ai-reporting' element={<AuthProvider><AIReporting /></AuthProvider>} />
          <Route path='payment/:id' element={<InvoiceDetail editor={false} />} />
          <Route path='inspection' element={<AuthProvider><InspectionMasterList /></AuthProvider>} />
          <Route path={'inspection/inspectionList/:id'} element={<AuthProvider><InspectionDataList /></AuthProvider>} />
          <Route path='workorder' element={<AuthProvider><WorkorderMasterList /></AuthProvider>} />
          <Route path={'workorder/workorderList/:id'} element={<AuthProvider><WorkorderDataList /></AuthProvider>} />
          <Route path='incident-reports/*' element={<AuthProvider><IncidentReport /></AuthProvider>} />
          <Route path="asset" element={<AuthProvider><MasterAssetSwitch /></AuthProvider>} />
          <Route path="asset/assetList/:id" element={<AuthProvider><AssetDataList /></AuthProvider>} />
        </Routes>

      </DrawerLayout>
    </>
  );
}
